// extracted by mini-css-extract-plugin
export default {"root":"FeaturedContent-module__root___aPoGF","headline":"FeaturedContent-module__headline___vQuIR","blocks":"FeaturedContent-module__blocks___Gty-P"};